import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import LoadingIndicator from '../LoadingIndicator'

import './styles.css'

class LoadMask extends Component {

    componentDidMount() {
        document.body.style.overflow = 'hidden'
    }

    componentWillUnmount() {
        document.body.style.overflow = 'visible'
    }

	render() {
		return (
            <CSSTransition
                classNames="LoadMask"
                in
                appear
                timeout={400}
            >
                <div style={{ zIndex: this.props.zIndex }} className="LoadMask__backdrop">
                    <LoadingIndicator text={this.props.text} />
                </div>
            </CSSTransition>
		)
	}
}

LoadMask.propTypes = {
    text: PropTypes.string,
}

export default LoadMask
